// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3rrYQ","header":"ReportDetails_header__Jehk4","title":"ReportDetails_title__27PoE","left":"ReportDetails_left__3LIYO"};